import type { IconSvgObject } from './types';

const PinLocation01Icon: IconSvgObject = [
  ["path", { d: "M12 11V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "7", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 16L17.9146 18.8292C18.4133 19.8265 17.688 21 16.5729 21H7.42705C6.31198 21 5.58674 19.8265 6.08541 18.8292L7.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PinLocation01Icon;
